import { Stack, Typography } from "@mui/material"

export function WidgetTotalContent({ typeCount, assetCount }) {
    return (
        <Stack>
            <Typography variant="h5" noWrap>
                {typeCount}
                <Typography
                    variant="caption"
                    color="text.secondary"
                    component="span"
                >{` (${"Asset Type".pluralize(typeCount)})`}</Typography>
            </Typography>
            <Typography variant="caption" color="text.secondary">
                {assetCount.toLocaleString()} {"Assets".pluralize(assetCount)}
            </Typography>
        </Stack>
    )
}
